var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{attrs:{"id":"Comp"}},[_c('div',{staticClass:"comp_container"},[_c('p',[_vm._v("회원가입이 완료 되었습니다.")]),_c('div',{staticClass:"btn_box"},[_c('button',{on:{"click":function($event){return _vm.$router.push('/login')}}},[_vm._v("로그인")]),_c('button',{on:{"click":function($event){return _vm.$router.push('/')}}},[_vm._v("메인")])])])])
}
var staticRenderFns = []

export { render, staticRenderFns }